import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

import AdminLayout from "../components/AdminLayout";
import AppSuspense from "../lib/suspense";

function AdminRoute({ children, currentSession, ...rest }) {
  if (currentSession) {
    if (currentSession.state === "OK") {
      if (currentSession.role_level > 10) {
        return <Redirect to="/public" />;
      }

      return (
        <Route {...rest}>
          <AdminLayout location={rest.location}>
            <AppSuspense>{children}</AppSuspense>
          </AdminLayout>
        </Route>
      );
    }

    if (currentSession.state === "LOCKED") {
      return <Redirect to="/locked-account" />;
    }

    return <Redirect to="/confirm-account" />;
  }

  return <Redirect to={`/login?redirectAfter=${window.location.pathname}${window.location.search}`} />;
}

function mapStateToProps(state) {
  return {
    currentSession: state.account.currentSession,
  };
}

export default connect(mapStateToProps)(AdminRoute);
